import { Tag, TagProps } from "antd";
import styled from "styled-components";
import Exclamation from "@/assets/icons/common/exclamation";

export function RenderbusTag({
  icon = <Exclamation />,
  color = "var(--color-main-alpha-1)",
  ...props
}: TagProps) {
  return <CustomTag icon={icon} color={color} {...props} />;
}

const CustomTag = styled(Tag)`
  line-height: 30px;
  min-height: 38px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 18px;
  margin-right: 0;
  white-space: normal;
  border: var(--color-bill-tip-border);
`;
